// extracted by mini-css-extract-plugin
export default {"SanitizedHtml":"use-labels-editor-module__SanitizedHtml--a8JK_","Box":"use-labels-editor-module__Box--EEJqt"};